import React from "react";
import TableBody from "@mui/material/TableBody";
import { bool, string } from "prop-types";
import { useParams } from "react-router";
import AnalysesTableDataSubRow from "./AnalysesTableDataSubRow";

import { tabKeyType, dataRowPropsType, analysisType } from "../../constants/proptypes";

import { connectToState } from "../../redux/connect-api";
import { activeTabKeySelector, analysisByIdSelector, dataRowPropsSelector } from "../../selectors";
import { userIsTrialSubscriberSelector } from "../../selectors/userProfile";

class AnalysesTableDataRow extends React.PureComponent {
  renderSubRows = () => {
    const { activeTabKey, analysisId, row, dataRowProps, subscriptionIsTrial } = this.props;

    return dataRowProps.map((subRowProps) => (
      <AnalysesTableDataSubRow
        suppressContent={subscriptionIsTrial}
        key={subRowProps.rowRenderKey}
        activeTabKey={activeTabKey}
        analysisId={analysisId}
        row={row}
        subRowProps={subRowProps}
      />
    ));
  };

  render() {
    const { analysisId, row } = this.props;
    const unpublished = row.unpublished ? "unpublished" : "";
    return (
      <TableBody id={analysisId} className={`data-row ${unpublished}`}>
        {this.renderSubRows()}
      </TableBody>
    );
  }
}

AnalysesTableDataRow.propTypes = {
  activeTabKey: tabKeyType.isRequired,
  analysisId: string.isRequired,
  dataRowProps: dataRowPropsType.isRequired,
  row: analysisType.isRequired,
  subscriptionIsTrial: bool,
};

const mapStateToProps = (state, ownProps) => ({
  activeTabKey: activeTabKeySelector(state, ownProps),
  dataRowProps: dataRowPropsSelector(state, ownProps),
  row: analysisByIdSelector(state, ownProps),
  subscriptionIsTrial: userIsTrialSubscriberSelector(state),
});

// Connect AnalysesTableDataRow (not the wrapper) so that route props are passed as ownProps
const ConnectedAnalysesTableDataRow = connectToState(mapStateToProps)(AnalysesTableDataRow);

// Export wrapper that injects router hooks and passes them as props to connected component
const AnalysesTableDataRowWithRouter = (props) => {
  const params = useParams();
  // Pass router props as ownProps so Redux connect sees them as changed
  // Create new object to ensure reference changes are detected
  return <ConnectedAnalysesTableDataRow {...props} params={{ ...params }} />;
};

export default AnalysesTableDataRowWithRouter;
